<template>
  <div class="chat-container" ref="chatContainer">
    <div class="chat-container-head">
      <el-avatar :size="60" class="flex-none avatar" :src="require('@/assets/robotaw.png')"></el-avatar>
    </div>
    <div v-for="(i,index) in talkMessages" :key="index" :ref="`talkMessages${index}`">
        <!-- system -->
      <div v-for="item in i.messages" :key="item.contentId" :class="item.creatorName == '用户' ? 'robot-box' : ''">
        <div v-if="item.creator == 'system' " class="text-center" style="color: rgb(136, 134, 134); font-size: 12px">
          {{ item.content }}
        </div>
        <example v-if="item.example" @send="_send" @sendTabId="getTabId"></example>
        <!-- 智能助手 -->
        <div class="flex" v-if="item.creatorName == '智能助手'" :ref="item.contentId">
          <div :class="[{'message-content-useful': item.creatorName == '智能助手' && item.usefulFlag && item.content !=='......'},'message-content flex-grow',
          {'message-content-maxW': item.isHello}]">

            <div :class="['message-content-inner']" v-if="item.type == 'text'">
              <!-- 新增的 -->
              <textContent :text="item.content"/>
              <div class="useful" v-if="item.creatorName == '智能助手' && item.usefulFlag && item.content !=='......'">
                <div :class="{'clickClass': item.useful && !item.useless}" @click="feedback('useful',item)">
                  <span class="iconfont">&#xe62a;</span>有用
                </div>
                <div :class="{'clickClass': item.useless && !item.useful}" @click="feedback('useless',item)">
                  <span class="iconfont">&#xe659;</span>没用
                </div>
              </div>
            </div>

            <!-- <div class="message-time">{{ item.createTime }}</div> -->
            <div class="message-buts scroll-y flex flex-nowrap" v-if="item?.btns?.length > 0">
              <!-- 新增的 -->
              <div class="list-items">
                <ul>
                  <li
                    v-for="(i, idx) in item?.btns"
                    :key="i.questionId"
                    
                    @click="handleBtnClick(item, i)"
                  >
                    <span v-if="item?.btns?.length > 1">{{ idx + 1 }}、</span>
                    <span>{{ i.questionContent }}</span>
                  </li>
                </ul>
              </div>
              <!-- 之前的代码 -->
              <!-- <el-button
                size="small"
                round
                v-for="i in item?.btns"
                :key="i.questionId"
                @click="handleBtnClick(item, i)"
                >{{ i.questionContent }}</el-button
              > -->
            </div>

            <div
              class="message-buts scroll-y flex flex-nowrap"
              v-if="item?.flowBtns?.length > 0 && item.flowBtnsShow == true">
              <el-button size="small" round v-for="i in item?.flowBtns" :key="i" @click="handleBtnClick(item, i, true)">{{
                i
              }}</el-button>
            </div>
          </div>
        </div>

        <!-- 用户 -->
        <div class="flex justify-end full-width" v-if="item.creatorName == '用户'">
          <div style="width: 70%; margin: 0 10px 15px 0" class="flex justify-end">
            <div class="robot-message-content">
              <div class="flex justify-end">
                <div class="robot-message-content-inner" v-html="item.content"></div>
              </div>
              <!-- <div class="message-time">{{ item.createTime }}</div> -->
            </div>
          </div>
        </div>
        <div class="aiMessage" v-if="item.isAi">- - - - - - - - <span>{{ item.aiContent }}</span> - - - - - - - -</div>
      </div>
    </div>
    
    <comment ref="comment" @success="commentSuccess"></comment>
    <div class="getTopNode" v-if="btnFlag" @click="pushTalkNode">
      <img :src="require('@/assets/qa7.png')"/>
    </div>
  </div>
</template>

<script>
import { parseTime } from "../utils/index";
import comment from "./comment.vue";
import example from "./example.vue";
import textContent from './textContent'

export default {
  name: "chatContent",
  components: {
    comment,
    example,
    textContent
  },
  data() {
    return {
      dialogVisible: true,
      messages: [], // 存储聊天消息
      conversationId: "",
      oldHeight: 0,
      nodes: {},
      flowId: null,
      nextNodes: {},
      nexNode: {},
      nowNode: {},
      userChatToken: this.$store.state.userChatToken,
      tabId: '0',
      unlessNum: 1,
      sendNum: 0,
      talkMessages: [],
      talkNum: null,
      btnFlag: false,
      scrollTopNum:'',
      isAi: false,
      questionMode: 1,
    };
  },
  computed: {
    // 计算属性，返回当前是否应该显示返回顶部按钮
    shouldShowBackToTop() {
      return this.scrollY >= this.threshold; // 假设滚动距离超过 500px 时显示按钮
    }
  },
  watch: {
    messages() {
      // this.scrollDomToBottom();
    },
    // 监控滑动距离的变化
    scrollTopNum() {
      if (this.scrollTopNum > 450) {
        this.btnFlag = true;
      } else {
        this.btnFlag = false;
      }
    },
    '$store.state.aiStatus': {
      handler(newVal,oldVal){
        this.isAi = newVal,
        this.questionMode = this.isAi ? '2' : '1',
        this.talkMessages[this.talkNum].messages.push({
          isAi: this.isAi ? '1' : '2',
          aiContent: this.isAi ? '当前为智能聊天模式' : '已退出智能聊天模式'});
        this.scrollDomToBottom();
      },
      deep: true,
    },
  },
  methods: {
    getTabId(e) {
      this.tabId = e
    },
    onFocus(e) {
      this.scrollDomToBottom();
    },
    _send(e, index) {
      console.log('点击推荐信息',e)
      console.log('点击推荐信息的id',e.id)
      this.tabId = e.questionCustomer || '0';
      this.talkNum = index ?  index : this.talkNum;
      
      this.talkMessages[this.talkNum].messages.push({
        content: e.flowName || e.questionContent,
        createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
        creator: null,
        creatorName: "用户",
        type: "text",
        ...e
      });
      
      this.recommendAim({id: String(BigInt(e.id))}).then((res) => {
        console.log('增加一次命中')
      }).catch(()=>{
        console.log('未增加一次命中')
      });
      this.getAnswer({questionMode: '1', questionCustomer: e.questionCustomer || '0' , questionContent: e.flowName || e.questionContent, flowId: String(BigInt(e.id))})
    },
    getUserTop() {
      console.log('this.$refs[`talkMessages${this.talkNum}`]',this.$refs[`talkMessages${this.talkNum}`])
      let myDiv = this.$refs[`talkMessages${this.talkNum}`][0]
      const elements = myDiv.getElementsByClassName('robot-box');
      
      if (elements.length > 0) {
        const lastElement = elements[elements.length - 1];
        console.log('lastElement', lastElement.offsetTop)
        const height = lastElement.offsetTop;
        const dom = this.$refs.chatContainer;
        
        if (dom) {
          requestAnimationFrame(() => {
            window.scrollTo(0, height - (window.innerHeight/2));
          });
        }
      }
    },
    getAnswer(e, num) {
      console.log('获得答案', e)

      this.$store.commit('SET_LOADING_STATE', true)
      let message = {
        createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
        creatorName: "智能助手",
        type: "text",
        useful: false,
        useless: false,
        content: '......'
      };
      this.talkMessages[this.talkNum].messages.push(message);
      this.recommendAnswer(e).then((res) => {
        let arr = []
        if(res.content && JSON.stringify(res.content.nextNodeId) !== '{}'){
          res.content.nextNodeId
          for( let key in res.content.nextNodeId ) {
            arr.push({
              id: key,
              name: res.content.nextNodeId[key],
              flowId: res.content.flowId
            })
          }
        }
        this.talkMessages[this.talkNum].messages.pop()
        let numArr = ['',1,2,3,4] 
        let answerArr = numArr.map(i=>{
          return res.content[`answerContent`+i]
        })
        let uniqueArr = answerArr.filter(i=>i !== null)
        uniqueArr.forEach(i=>{
          message = {
            ...message,
            content: i =='' ? '抱歉我还不能理解您的意思' : i,
            question: e.questionContent,
            ...res.content,
            nextNodeList: arr,
            usefulFlag: JSON.stringify(res.content.nextNodeId) == '{}' || res.content.nextNodeId == null
          }
          this.talkMessages[this.talkNum].messages.push(message);
        })
        if(num && num == 3) {
          this.answerCover().then((res) => {
            if(res.content) {
              this.talkMessages[this.talkNum].messages.push({
                content: res.content.answerContent,
                createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
                creatorName: "智能助手",
                type: "text",
              });
            }
          })
          this.sendNum = 0
        }
        this.$store.commit('SET_LOADING_STATE', false)
        this.$store.commit('SET_ARR', arr)
        // this.scrollDomToBottom()
        this.getUserTop()
        this.getLastItem()
      }).catch(()=>{
        this.talkMessages[this.talkNum].messages.pop()
        message = {
          ...message,
          content: '抱歉我还不能理解您的意思',
          question: '',
          nextNodeList: []
        }
        this.$store.commit('SET_LOADING_STATE', false)
        this.talkMessages[this.talkNum].messages.push(message);
        this.getLastItem()
      });
      
    },
    /* 正常对话消息 */
    sendMessage(text, needPush = true) {
      this.$emit('getNewResult',text.trim())
      if (text.trim() === "") {
        return;
      }
      this.sendNum ++
      // this.questionMode 是智能模式开关，暂时隐藏
      // this.setUser(text.trim(), {questionMode: this.questionMode, questionCustomer: 0,questionContent:text.trim()},needPush = true, this.sendNum)
      this.setUser(text.trim(), {questionMode: '2', questionCustomer: 0,questionContent:text.trim()},needPush = true, this.sendNum)
    },
    setUser(name, e, needPush = true, num, talkNum) {
      this.messages = this.messages.map((i,index)=>{
          i.noClick = index == this.messages.length+1 ? false : false
        return i
      })
      if (needPush) {
        this.talkMessages[this.talkNum].messages.push({
          content: name,
          createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
          creator: null,
          question: name,
          creatorName: "用户",
          type: "text",
        });
        
      }
      this.getAnswer(e,num)
      // this.getLastItem()
    },
    getLastItem() {
      let filterArr = this.talkMessages[this.talkNum].messages.filter(i=>i.creatorName =='智能助手' && i.flowId)
      if(filterArr.length > 0) {
        let lastItem = filterArr[filterArr.length - 1]
        let str = ''
        filterArr.forEach(i=>{
          str += i.content
        })
        
        if(!lastItem.useful && !lastItem.useless) {
          this.addHistory({ userId: JSON.parse(localStorage.getItem("user")).userId, chatQuestion: lastItem.question, chatAnswer: str, chatUseful: ''}).then((res) => {
            console.log('是否有用',res)
          }).catch((err)=>{
            console.log('是否有用err',err)
          });
        }
      }
    },
   
    /* 流程消息 */
    flowMessage(question) {
      console.log('流程')
      
      this.$axios
        .get(`/conversation/arrive/${this.flowId}/${this.nodeId}`, {
          flowId: this.flowId,
          nodeId: this.nodeId,
          question,
        })
        .then((res) => {
          if (res.status == 0) {
            this.arriveData = res.content;
            this.nodeId = res?.content?.nodeId;
            if (res.content?.reply?.replies) {
              let data = {
                createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
                creatorName: "智能助手",
                content: res.content.reply.replies[0].content,
                type: "text",
              };
              this.talkMessages[this.talkNum].messages.push(data);
            } else if (!res.content) {
              this.flowId = null;
              this.nodeId = null;
              this.sendMessage(question == null ? "" : question, false);
            } else {
              let data = {
                createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
                creatorName: "智能助手",
                content: res.content.content,
                type: "text",
              };
              /* 按钮组 */
              if (res.content.options) {
                data.flowBtnsShow = true;
                data.flowBtns = res.content.options.split(",");
              }
              this.talkMessages[this.talkNum].messages.push(data);
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((err) => {
          this.flowId = null;
          this.nodeId = null;
          this.$message.error("系统错误");
        });
    },
    /* 按钮发送消息 */
    async handleBtnClick(item, btn, isFLow) {
      if(item.noClick){
        return
      }else{

        if (isFLow && this.flowId) {
          item.flowBtnsShow = false;
          this.talkMessages[this.talkNum].messages.push({
            content: btn.trim(),
            createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
            creator: null,
            creatorName: "用户",
            type: "text",
          });

          this.flowMessage(btn);
        } else {
          // item.btnsShow = false;
          this.talkMessages[this.talkNum].messages.push({
            content: btn.questionContent.trim(),
            createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
            creator: null,
            creatorName: "用户",
            type: "text",
          });
          let message = {
            createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
            creatorName: "智能助手",
            type: "text",
          };
          
          this.recommendAnswer({ questionCustomer: 0, questionContent: btn.questionContent.trim(),originQuestionId:btn.questionId})
          .then((res) => {
            if(JSON.stringify(res.content.bestRecommendAnswer) === '{}'){
              message.content = "抱歉我还不能理解您的意思";
            }else {
              message.content = res.content.bestRecommendAnswer?.robotAnswer
            }
            message.noClick = false
            this.messages.map(i=>{
  
              i.noClick  = true
              return i
            })
            
          }).catch(()=>{
            message.content = "抱歉我还不能理解您的意思";
          });
        
        }
      }
    },
    async getQuestion(text,message) {
      let questions = await this.recommendMessage(text);
        if (questions.content?.bestRecommendQuestionList.length > 0) {
          message.btns = questions.content.bestRecommendQuestionList.slice(0, 20);
          message.btnsShow = true;
        }
        this.messages.push(message);
    },
    recommendMessage(e) {
      return this.$axios.get("/conversation/recommend/question", { originQuestionContent: e, userChatToken: this.$store.state.userChatToken }).then((res) => {
        return res;
      });
    },
    recommendAnswer(e) {
      return this.$axios.get("/conversation/answer/question", { ...e, userToken: this.$store.state.userChatToken }).then((res) => {
        return res;
      });
    },
    recommendAim(e) {
      return this.$axios.get("/conversation/aim/recommend", { ...e }).then((res) => {
        return res;
      });
    },
    answerCover(e) {
      return this.$axios.get("/conversation/answer/cover").then((res) => {
        return res;
      });
    },
    addHistory(e) {
      return this.$axios.post("/conversation/add/history", { ...e }).then((res) => {
        return res;
      });
    },
    /* 对话历史 */
    getConversation(notFirst) {
        if(notFirst) {
          this.messages = [];
          this.messages.push({ example: true });
          this.talkMessages.push({messages:this.messages});
          this.talkNum = this.talkMessages.length -1;
          // this.scrollDomToBottom();
          
        }else{
          this.$axios.get("/conversation").then((res) => {
            if (res.status == 0) {
              this.historyList = res.content;
              if (res.content.length == 0) {
                this.getConversationHello(notFirst);
              } else {
                let arr = [];
                res.content.forEach((item) => {
                  item.contentList.forEach((i) => {
                    if (i.toUserName == "智能助手") {
                      arr.push({ ...i, creatorName: "用户"});
                    } else {
                      arr.push({ ...i, type: "text"});
                    }
                  });
                });
                this.messages = arr;
                this.messages.push({ example: true });
                this.talkMessages.push({messages:this.messages})
                this.talkNum = this.talkMessages.length -1
                this.$nextTick(() => {
                });
              }
            }
          });
        }
    },
    /* 欢迎语 */
    getConversationHello(notFirst) {
      if(notFirst) {
          this.messages = [];
          this.messages.push({ example: true });
          this.talkMessages.push({messages:this.messages});
          this.talkNum = this.talkMessages.length -1;
          this.scrollDomToBottom();
        }else{
          this.$axios.get("/conversation/welcome").then((res) => {
            if (res.status == 0) {
              this.messages.push({
                createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
                creatorName: "智能助手",
                content: res.content.greetingContent,
                type: "text",
                isHello: true
              });
              this.messages.push({ example: true });
              this.talkMessages.push({messages:this.messages})
              this.talkNum = this.talkMessages.length -1
              this.conversationId = res.content.conversationId;
            }
          });
        }
    },
    /* 系统提示 */
    systemInfo(data) {
      if ((data.type = "over")) {
        this.messages.push({
          content: "当前会话已结束",
          createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
          creator: "system",
          creatorName: "system",
          type: "text",
        });
      }
    },
    /* 滚动到底部 */
    scrollDomToBottom() {
      const dom = this.$refs.chatContainer;
      console.log('window.innerHeight', window.innerHeight)
      
      if (dom) {
        this.oldHeight = dom.scrollHeight - dom.clientHeight;
        requestAnimationFrame(() => {
          // dom.scrollTo(0, dom.scrollHeight - dom.clientHeight);
          window.scrollTo(0, document.body.scrollHeight - window.innerHeight);
        });
      }
    },
    commentSuccess() {
      this.messages.push({
        content: "留言已提交，请等待工作人员回复",
        createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
        creator: "system",
        creatorName: "system",
        type: "text",
      });
    },
    handleComment() {
      this.$refs.comment.open();
    },
    // 有用没用
    feedback(e,item) {
      if(e == 'useless') {
        if(this.unlessNum == 3) {
          this.answerCover().then((res) => {
            if(res.content) {
              this.talkMessages[this.talkNum].messages.push({
                content: res.content.answerContent,
                createTime: parseTime(new Date(), "yyyy-MM-dd hh:mm:ss"),
                creatorName: "智能助手",
                type: "text",
              });
            }
            this.unlessNum = 1
          })
        }else{

          this.unlessNum ++;
        }
      }
      if(!item.useful && !item.useless){
        item[e] = !item[e]
        this.addHistory({ userId: JSON.parse(localStorage.getItem("user")).openId, chatQuestion: item.question, chatAnswer: item.content, chatUseful:e =='useful' ? true : false}).then((res) => {
          console.log('是否有用',res)
        }).catch((err)=>{
          console.log('是否有用err',err)
        });
      }else{
        return;
      }
    },
    // 获取下一个节点答案

    getNextNode(e) {
      console.log('下一个节点',e,this.tabId)
      console.log('点击下一个节点获取当前数组的index',this.talkNum)
      this.setUser(e.name, {questionMode:1, questionCustomer:this.tabId, flowId: e.flowId,nodeId: e.id,questionContent:e.name})
    },
    toInfo(e) {
      console.log('点击的问题')
      
    },
    pushTalkNode() {
      this.$store.commit('SET_ARR', []);
      this.getConversationHello(true);
      this.sendNum = 0;
      this.unlessNum = 1;
    },
    //实时监控元素与窗口滚动的距离
    handleScroll(e) {
      return
      this.$nextTick(()=>{
        let top = this.$refs.chatContainer.scrollTop
        this.scrollTopNum = top;
      })
      
    }
   
  },
  mounted() {
    let _this = this
    window.addEventListener('resize', function(){
      // 根据键盘高度调整布局
      // const user = navigator.userAgent
      // let isIos = !!user.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // let keyboardHeight =  window.innerHeight < screen.height ? screen.height - window.innerHeight : 0
      // if (isIos) {
      //   _this.$refs.chatContainer.style.paddingTop = keyboardHeight + 'px'
      // }
    });
   
  },
};
</script>
<style>
p {
  margin: 0 !important;
}
</style>
<style lang="scss" scoped>
.aiMessage{
  text-align: center;
  color: #a2a2a4;
  font-size: 12px;
  margin: 20px 0;
  span{
    padding: 0 10px
  }
}
.getTopNode{
  width: 36px;
  height: 46px;
  position: fixed;
  bottom: 120px;
  right: 10px;
  // border-radius: 4px;
  z-index: 999;
  img{
    width: 100%;
    height: 100%;
  }
}
.el-avatar{
  color: #C0C4CC !important;
  background: #fff !important;
}
.chat-container-head{
  text-align: center;
  margin-bottom: 20px;
  .avatar{
    background: #3b62f1 !important;
  }
  .chat-container-time{
    width: 160px;
    height: 26px;
    border-radius: 15px;
    background: #eee;
    color: #333;
    line-height: 26px;
    margin: 5px auto;
  }
}
.el-avatar--icon {
    font-size: 22px !important;
}
// 新增的
.list-items {
  background-color: #f5f6f8;
  padding: 10px;
  border-radius: 4px;
  ul li {
    line-height: 22px;
    font-size: 12px;
    &:hover {
      color: #409EFF;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
}

// 之前的代码
.robot-message-content {
  div {
    text-align: right;
  }

  .robot-message-content-inner {
    // width: 100%;
    display: inline-block;
    padding: 10px;
    position: relative;
    background-color: #3b62f1;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.5;
    text-align: left;
    color: #fff;
  }
  .robot-message-content-inner::before {
    position: absolute;
    top: 0;
    right: -10px;
    // z-index: 2;
    width: 0;
    height: 0;
    border-bottom: 15px solid transparent;
    content: "";
    border-left: 22px solid #3b62f1;
  }
}
.message-content {
  max-width: 70%;
  margin-left: 10px;
  position: relative;
  .useful{
    position: absolute;
    right: 0;
    bottom: -40px;
    background: #f5f6f8;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    display: flex;
    align-items: center;
    box-shadow: 0 0 5px #f5f6f8;
    div{
      &.clickClass{
        color: #3b62f1;
        pointer-events: none;
      }
      .iconfont{
        font-size: 14px;
      }
      &:nth-of-type(1) {
        border-right: 1px solid #ccc;
        margin-right: 10px;
        padding-right: 10px;
      }
      span {
        margin-right: 5px;
      }
    }
  }
}
.message-content-maxW{
  max-width: 95%;
}
.message-content-useful{
  margin-bottom: 50px;;
}
.avatar {
  margin-top: 14px;
}
.message-name,
.message-time {
  color: #666;
  font-size: 12px;
  line-height: 30px;
  height: 20px;
}
.message-content-inner {
  display: inline-block;
  padding: 10px;
  position: relative;
  background-color: #f5f6f8;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
  box-shadow: 0 0 5px #f5f6f8;
  margin-bottom: 15px;
}
// .message-content-inner-w{
//   width: 100%;
// }

.message-content-inner::before {
  position: absolute;
  top: 0;
  left: -8px;
  // z-index: 2;
  width: 0;
  height: 0;
  // border-top: 8px solid transparent;
  border-bottom: 12px solid transparent;
  content: "";
  border-right: 13px solid #f5f6f8;
}
.chat-container {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 10px 120px;
  box-sizing: border-box;
  background: linear-gradient(to bottom right, #b8c9f8, #dcdcf8, #eaeef6)

}

.message-out {
  width: 100%;
  display: flex;
  justify-content: start;
  overflow: hidden;
  flex-direction: column;
}
.message {
  margin: 10px;
  padding: 10px;
  border-radius: 10px;
  text-align: left;
  max-width: 70%;
  text-wrap: wrap;
  word-break: break-all;
  background-color: rgb(231, 248, 255);
  color: #000;
}
.time {
  text-align: left;
  max-width: 70%;
}
.robot-message {
  justify-content: end;
  .message {
    text-align: left;
    background-color: #95ec69;
  }
}
</style>
